<template>
    <div v-if="variants">
        <label for="" class="mt-5">{{ $t("text.varianter") }}</label>
        <table class="table variants">
            <thead>
                <tr>
                    <th v-if="showTranslation"></th>
                    <th>{{ $t("form.namn") }}</th>
                    <th>{{ $t("form.artnr") }}</th>
                    <th colspan="2" v-if="showOriginal">{{ $t("form.enr") }}</th>
                    <th colspan="2" v-if="showTranslation">{{ $t("form.nobnr") }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(variant, i) in variants" :key="`variants-${i}`">
                    <td><span v-if="origVariants[i]" class="text-nowrap">{{ origVariants[i].title }}</span></td>
                    <td>
                        <FormElementInput notitle name="title" v-model="variant.title"
                            @input="variant.title = $event" />
                    </td>
                    <td>
                        <FormElementInput notitle name="artnr" v-model="variant.artnr"
                            @input="variant.artnr = $event" />
                    </td>
                    <td v-if="showOriginal">
                        <FormElementInput notitle nohelp name="enr" v-model="variant.enr"
                            @input="variant.enr = $event" />
                    </td>
                    <td v-if="showTranslation">
                        <FormElementInput notitle nohelp name="nobnr" v-model="variant.nobnr"
                            @input="variant.nobnr = $event" />
                    </td>
                    <td width="5" v-if="showOriginal">
                        <button class="btn btn-danger" @click="removeVariant(variant.artnr, $event)"><b-icon
                                icon="dash"></b-icon></button>
                    </td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td colspan="4" align="right"><small>{{ $t('form.enr-help') }}</small></td>
                    <td align="right" v-if="showOriginal">
                        <button type="button" class="btn btn-success"
                            @click="variants.push({ title: '', artnr: '' })">{{ $t("text.admin.lagg-till-variant") }}
                            <b-icon icon="plus"></b-icon></button>
                    </td>
                </tr>
            </tfoot>
        </table>
    </div>
</template>

<script>
import AdminAccessMixin from '@/mixins/AdminAccessMixin';
import FormElementInput from './FormElementInput.vue';
export default {
    name: "AdminProductVariants",
    mixins: [AdminAccessMixin],
    components: {
        FormElementInput
    },
    props: ["value", "origVariants"],
    computed: {
        variants: {
            get: function () {
                return this.value
            },
            set: function (value) {
                this.$emit('input', value)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../../../../scss/_colors.scss";

table {

    th,
    td {
        border-width: 2px;
        border-color: white;
    }

    th {
        background-color: $primary;
        color: $white;
    }

    td {
        background-color: $gray-100;
    }
}
</style>
